import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { COMMAND_CENTER_COMPANY_VOLUME_ACTION_TYPE } from '../actions/companyVolume.actions';

const initialState = null;

const companyVolumeReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case COMMAND_CENTER_COMPANY_VOLUME_ACTION_TYPE.SET_COMPANY_VOLUME:
        return payload ?? initialState;

      case RESET_STATE:
        return initialState;

      default:
        return draft;
    }
  });

export default companyVolumeReducer;
